import { render, staticRenderFns } from "./ContactView.vue?vue&type=template&id=c1b8ec20&"
import script from "./ContactView.vue?vue&type=script&lang=js&"
export * from "./ContactView.vue?vue&type=script&lang=js&"
import style0 from "./ContactView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports